import React from 'react';
import PropTypes from 'prop-types';

import {
  PDP_READYTOSHIP_TAB_ID,
  PDP_DECIDELATER_TAB_ID,
} from 'commons/constants';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import usePdpIsModularBYOProduct from 'components/consumer/PDP/state/context/usePdpIsModularBYOProduct';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import PDPChooseYourOptionsUIInner from './PDPChooseYourOptionsUI';
import usePDPOptions from '../state/context/usePDPOptions';
import usePDPStockAvailability from '../state/context/usePDPStockAvailability';
import PDPChooseYourOptionsPlaceholder from './PDPChooseYourOptionsPlaceholder';

const PDPChooseYourOptionsInner = ({
  isEditOrder = false,
  mode = 'pdp',
  onMoreMaterialsClick,
  setMarxentSelectedFabric,
  slug,
}) => {
  const {
    loading: basicDetailsLoading,
    data: basicDetailsData,
  } = usePDPBasicDetails();

  const {
    loading,
    data: { options = [], upholsteryOptionId, stock = {} } = {},
  } = usePDPOptions();

  const pdpIsModularBYOProduct = usePdpIsModularBYOProduct();

  const {
    data: { isMarkedOOSOrDiscontinued, isStockLoading },
  } = usePDPStockAvailability();

  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();

  const {
    id,
    efg_flag,
    custom_properties: { option_selector: optionSelector = '' } = {},
  } = basicDetailsData ?? {};

  const isRTSTab = pdpSelectedCustomizerTab === PDP_READYTOSHIP_TAB_ID;
  const isDecideLaterTab = pdpSelectedCustomizerTab === PDP_DECIDELATER_TAB_ID;

  return (
    <PDPChooseYourOptionsUIInner
      pdpIsModularBYOProduct={pdpIsModularBYOProduct}
      isDecideLaterTab={isDecideLaterTab}
      isEditOrder={isEditOrder}
      isFFG={!efg_flag}
      isRTSTab={isRTSTab}
      loading={
        loading ||
        basicDetailsLoading ||
        (isMarkedOOSOrDiscontinued && isStockLoading)
      }
      mode={mode}
      onMoreMaterialsClick={onMoreMaterialsClick}
      options={isRTSTab ? stock?.stockOptions : options}
      productId={id}
      selectionValidity={stock?.selectionValidity}
      slug={slug}
      optionSelector={optionSelector}
      upholsteryOptionId={upholsteryOptionId}
      setMarxentSelectedFabric={setMarxentSelectedFabric}
    />
  );
};

PDPChooseYourOptionsInner.propTypes = {
  isEditOrder: PropTypes.bool,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  onMoreMaterialsClick: PropTypes.func,
  setMarxentSelectedFabric: PropTypes.func,
  slug: PropTypes.string,
};

const PDPChooseYourOptions = props => (
  <SuspenseWithLoader fallback={<PDPChooseYourOptionsPlaceholder />}>
    <PDPChooseYourOptionsInner {...props} />
  </SuspenseWithLoader>
);

export default PDPChooseYourOptions;
